if (!customElements.get('product-list')) {
  customElements.define(
    'product-list',
    class extends HTMLElement {
      constructor() {
        super();
        const mainSearchId = this.dataset['containerId'];
        this.mainSearch = this.querySelector(`#${mainSearchId}`);

        this.reset = this.querySelector('[data-reset]');
        this.form = this.querySelector('.search-field__input');

        const filterIsOpenClass = 'filter-is-open';

        let isMobile = false;
        // Close filters on mobile
        if (window.innerWidth < 768) {
          this.mainSearch.classList.remove(filterIsOpenClass);
          isMobile = true;
        }

        window.addEventListener('resize', () => {
          if (window.innerWidth <= 768) {
            if (!isMobile) {
              isMobile = true;
            }
          } else {
            if (isMobile) {
              this.mainSearch.classList.add(filterIsOpenClass);
              isMobile = false;
            }
          }
        });

        this.reset?.addEventListener('click', () => {
          this.form.value = '';
        });
      }
    }
  );
}
